import { Component, Inject, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { CommunicationsService } from "../../../../auth/service/communications.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { DOCUMENT } from "@angular/common";
import { AuthenticationService } from "../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-list-Communications",
  templateUrl: "./list-notifications.component.html",
  styleUrls: ["./list-notifications.component.scss"],
})
export class NotificationListComponent implements OnInit {
  public contentHeader: IContentHeader;

  public communicationsList: any = [];

  public searchKeyword: string = "";

  public categories: any = [];

  public selectedCategory: string = "all";

  public selectedStatus: string = "all";

  public selectedCommunication: any;

  public statuses_labels: any;

  public pageBasicText: any = 1;

  public pageSize = 10;

  public statusColor: Array<string> = ["secondary", "warning", "success", "danger"];

  public today: any = moment();

  public isLoaded: boolean = false;

  public filteredCommunication: any = "";

  constructor(
    @Inject(DOCUMENT) private _document: any,
    public _communicationService: CommunicationsService,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    private _domSanitizer: DomSanitizer,
    public _authenticationService: AuthenticationService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.LIST_NOTIFICATIONS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.LIST_NOTIFICATIONS,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this._utilService.showLoading();
    if (this._communicationService.list.length < 1) {
      await this._communicationService.getList();
    }
    this.statuses_labels = await this._utilService.translate("STATUS");
    this.categories = await this._communicationService.getListCategories();
    await this.loadCommunications().then(() => this._utilService.hideLoading());
    this.filterCommunications();
    this._utilService.hideLoading();
  }

  async loadCommunications() {
    this.communicationsList = this._communicationService.list.map((Communication: any) => {
      return { ...Communication, ...this.getCommunicationStatus(Communication) };
    });
    setTimeout(() => (this.isLoaded = true));
  }

  filterCommunications() {
    let items: any = this.communicationsList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();
    const category: string = this.selectedCategory.trim().toLowerCase();
    const status: string = this.selectedStatus.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) => item?.title?.toLowerCase().includes(keywords));
    }
    if (category.length > 0 && category !== "all") {
      items = items.filter((item: any) => item?.category_name?.toLowerCase().includes(category));
    }
    if (status.length > 0 && status !== "all") {
      items = items.filter((item: any) => item?.statusLabel?.toLowerCase().includes(status));
    }
    this.filteredCommunication = items;
  }

  async modalOpen(modalBasic, notificationID: number) {
    this.selectedCommunication = this.communicationsList.find((communication) => communication.id === notificationID);
    this.selectedCommunication.send_date = moment(this.selectedCommunication.send_date);

    const statuses: any = this.getCommunicationStatus(this.selectedCommunication);
    if (!statuses) {
      //Nel caso statuses sia vuoto diamo un errore perchè in questo caso la notifica non ha utenti destinatari all'interno
      await this._utilService.showSWALError({ text: "NOTIFICATION_NOT_FOUND_USER" });
      return false;
    }
    this.selectedCommunication.statusLabel = statuses.statusLabel;
    this.selectedCommunication.status = statuses.status;

    this.selectedCommunication.hasMoreThan5 = this.selectedCommunication.users.length > 4;

    this.showMoreCommunicationUsers("more");
    if (this.selectedCommunication.hasMoreThan5) {
      this.showMoreCommunicationUsers("less");
    }

    this.selectedCommunication.users = this.selectedCommunication.users.map((item: any) => {
      if (item.status === 0) {
        item.statusLabel = this.statuses_labels.PENDING;
      } else if (item.status === 3) {
        item.statusLabel = this.statuses_labels.ERROR;
      } else if (item.status === 1) {
        item.statusLabel = this.statuses_labels.PROCESSING;
      } else if (item.status === 2) {
        item.statusLabel = this.statuses_labels.COMPLETED;
      }
      return item;
    });

    this._modalService.open(modalBasic, {
      size: "l",
      centered: true,
    });
  }

  transform(html: string): SafeHtml {
    return this._domSanitizer.bypassSecurityTrustHtml(html);
  }

  showMoreCommunicationUsers(quantity: string) {
    this.selectedCommunication.users_list = quantity === "less" ? this.selectedCommunication.users_list.slice(0, 5) : (this.selectedCommunication.users_list = this.selectedCommunication.users);
  }

  getCommunicationStatus(communication: any) {
    //Controllo che ci siano user, nel caso non ci siano users saltiamo questa funzione per non andare in errore
    if (communication && communication.users && communication.users.length > 0) {
      const statuses: number[] = communication.users.map((u: any) => Number(u.status));

      let statusLabel: any = this.statuses_labels.COMPLETED;
      let status: number = 2;

      if (statuses.filter((s: number) => s === 0).length > 0) {
        status = 0;
        statusLabel = this.statuses_labels.PENDING;
      } else if (statuses.filter((s: number) => s === 3).length > 0) {
        status = 3;
        statusLabel = this.statuses_labels.ERROR;
      } else if (statuses.filter((s: number) => s === 1).length > 0) {
        status = 1;
        statusLabel = this.statuses_labels.PROCESSING;
      }

      return { statusLabel, status };
    }
  }

  async deleteCommunication(selectedCommunication) {
    if (!this._authenticationService.hasCapability("delete_notification")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += selectedCommunication.title;
    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._communicationService.delete(selectedCommunication.id);
          this._utilService.hideLoading();
          await this._utilService.showPopupItemDeleted();
          await this.loadCommunications();
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_REMOVE_COMMUNICATION" }));
  }
}
